module.exports = __webpack_public_path__ + "23b118569a44ded10ca94d7cff7db4e8.pdf";